"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Growl;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _currencyModal = _interopRequireDefault(require("./currency-modal.js"));
var _index = _interopRequireDefault(require("../../elements/buttons/link/index.js"));
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const CloseButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "CloseButton",
  class: "pl-cvxm25i"
});
const GrowlWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GrowlWrapper",
  class: "pl-g1jrcwh5"
});

/**
 * Growl component.
 * @module Growl
 *
 * @param {Object} props React props
 * @param {string} props.title The item's title
 * @param {string} props.content Content text
 * @param {string} props.fadeOut FadeOut value to close the component ("none", "5000")
 * @param {string} props.modalTitle Modal title
 * @param {string} props.modalContent Modal content
 * @param {string} props.modalTrigger Modal trigger text
 * @param {string} props.setCurrencyUrl Set currency url
 * @param {string} props.selectedCurrency Selected currency
 * @param {string} props.primaryCurrencies Primary currencies
 * @param {string} props.allCurrencies All currencies
 * @param {string} props._name Name of the component
 * @returns {React.ReactElement} Growl component.
 * @public
 */
function Growl({
  _name,
  title,
  content,
  fadeOut = 'none',
  modalTrigger
}) {
  const [showGrowl, setShowGrowl] = (0, _react.useState)(false);
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const closeButtonRef = (0, _react.useRef)(null);
  const {
    modalDialog: {
      title: modalTitle,
      content: modalContent,
      setCurrencyUrl,
      selectedCurrency,
      primaryCurrencies,
      allCurrencies
    }
  } = modalTrigger;
  (0, _react.useEffect)(() => {
    if (sessionStorage.getItem('shownGrowl') !== 'true') {
      setShowGrowl(true);
      if (closeButtonRef.current) {
        closeButtonRef.current.focus();
      }
      if (fadeOut !== 'none') {
        setTimeout(() => {
          closeGrowl();
        }, fadeOut);
      }
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (showModal) {
      closeGrowl();
    }
  }, [showModal]);
  function closeGrowl() {
    setShowGrowl(false);
    sessionStorage.setItem('shownGrowl', 'true');
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(GrowlWrapper, (0, _extends2.default)({
    "data-cy": "growl",
    "data-show": showGrowl,
    "aria-hidden": !showGrowl,
    fadeOut: fadeOut
  }, _patternLibraryUtils.tracking.create(_name, false, false)), /*#__PURE__*/_react.default.createElement(CloseButton, (0, _extends2.default)({
    "data-cy": "close-button",
    ref: closeButtonRef,
    onClick: closeGrowl
  }, _patternLibraryUtils.tracking.create('dismiss', true, false)), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "x",
    className: "close",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    className: "growl-title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "growl-content",
    className: "content"
  }, content, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    onClick: () => setShowModal(true),
    text: modalTrigger?.text,
    dataCy: "growl-modal-trigger"
  }, _patternLibraryUtils.tracking.create(_name + '_modal', true, false))))), showModal && /*#__PURE__*/_react.default.createElement(_currencyModal.default, {
    title: modalTitle,
    content: modalContent,
    showModal: showModal,
    setShowModal: setShowModal,
    setCurrencyUrl: setCurrencyUrl,
    selectedCurrency: selectedCurrency,
    primaryCurrencies: primaryCurrencies,
    allCurrencies: allCurrencies
  }));
}
Growl.propTypes = {
  _name: _propTypes.default.string,
  title: _propTypes.default.string,
  content: _propTypes.default.string,
  fadeOut: _propTypes.default.string,
  setCurrencyUrl: _propTypes.default.string,
  modalTrigger: _propTypes.default.shape({
    text: _propTypes.default.string,
    // Currency Modal
    modalDialog: _propTypes.default.shape({
      title: _propTypes.default.string,
      content: _propTypes.default.string,
      setCurrencyUrl: _propTypes.default.string,
      selectedCurrency: _propTypes.default.shape({
        id: _propTypes.default.string,
        symbol: _propTypes.default.shape({
          HasValue: _propTypes.default.bool,
          Value: _propTypes.default.string
        }),
        description: _propTypes.default.string
      }),
      primaryCurrencies: _propTypes.default.arrayOf({
        id: _propTypes.default.string,
        symbol: _propTypes.default.shape({
          HasValue: _propTypes.default.bool,
          Value: _propTypes.default.string
        }),
        description: _propTypes.default.string
      }),
      allCurrencies: _propTypes.default.arrayOf({
        id: _propTypes.default.string,
        symbol: _propTypes.default.shape({
          HasValue: _propTypes.default.bool,
          Value: _propTypes.default.string
        }),
        description: _propTypes.default.string
      })
    })
  })
};